import { useMutation } from 'react-query'
import { deleteOnlyApiUser } from 'services/cmAPI/deletOnlyApiUser'

export function useDeleteOnlyApiUser({ onSuccess, onError }) {
  return useMutation(deleteOnlyApiUser, {
    onSuccess,
    onError,
  })
}
